import React from "react";

const FooterSection = () => {
  return (
    <footer className="py-8 border-t border-white">
      <div className="container mx-auto px-6 text-center text-white">
        <p>&copy; 2025 IVRVue, Inc. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default FooterSection;
